(function () {
  var cartDrawer, cartBody, cartCountEls;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '₹' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function injectStyles() {
    var css = [
      '.hyp-cart-overlay{position:fixed;inset:0;background:rgba(11,11,11,.5);z-index:98;opacity:0;pointer-events:none;transition:opacity .3s}',
      '.hyp-cart-overlay.hyp-open{opacity:1;pointer-events:auto}',
      '.hyp-cart-drawer{position:fixed;top:0;right:0;height:100%;width:min(420px,92vw);background:#f5f1e8;color:#0b0b0b;z-index:99;transform:translateX(100%);transition:transform .35s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;font-family:"Space Grotesk",sans-serif;box-shadow:-10px 0 40px rgba(0,0,0,.2)}',
      '.hyp-cart-drawer.hyp-open{transform:translateX(0)}',
      '.hyp-cart-head{display:flex;justify-content:space-between;align-items:center;padding:22px 24px;border-bottom:1px solid #d8d2c6}',
      '.hyp-cart-head h3{font:26px/1 "Anton",sans-serif;margin:0;letter-spacing:-1px}',
      '.hyp-cart-close{background:none;border:1px solid #111;border-radius:50%;width:34px;height:34px;cursor:pointer;font-size:15px}',
      '.hyp-cart-items{flex:1;overflow-y:auto;padding:10px 24px}',
      '.hyp-cart-empty{padding:60px 0;text-align:center;color:#77736b;font:11px "DM Mono",monospace;letter-spacing:1px}',
      '.hyp-cart-line{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #e3ddd1}',
      '.hyp-cart-line img{width:72px;height:86px;object-fit:cover;background:#e7e1d6}',
      '.hyp-cart-line-info{flex:1;display:flex;flex-direction:column;justify-content:center}',
      '.hyp-cart-line-title{font-size:13px;font-weight:700;margin:0 0 4px}',
      '.hyp-cart-line-variant{font:10px "DM Mono",monospace;color:#77736b;margin:0 0 8px}',
      '.hyp-cart-qty{display:flex;align-items:center;gap:10px}',
      '.hyp-cart-qty button{width:22px;height:22px;border:1px solid #111;background:none;cursor:pointer;font-size:12px;line-height:1}',
      '.hyp-cart-qty span{font:11px "DM Mono",monospace;min-width:14px;text-align:center}',
      '.hyp-cart-line-price{font:700 12px "DM Mono",monospace;text-align:right;min-width:60px}',
      '.hyp-cart-remove{font:9px "DM Mono",monospace;color:#ff4b20;background:none;border:none;cursor:pointer;padding:0;margin-top:6px;text-align:left}',
      '.hyp-cart-foot{border-top:1px solid #d8d2c6;padding:20px 24px 26px}',
      '.hyp-cart-subtotal{display:flex;justify-content:space-between;font:700 14px "DM Mono",monospace;margin-bottom:14px}',
      '.hyp-cart-checkout{display:block;width:100%;text-align:center;background:#ff4b20;color:#fff;border:1px solid #ff4b20;padding:16px;font:700 11px "DM Mono",monospace;letter-spacing:1px;cursor:pointer}',
      '.hyp-cart-count-badge{position:absolute;top:-6px;right:-6px;background:#ff4b20;color:#fff;font:9px "DM Mono",monospace;width:16px;height:16px;border-radius:50%;display:flex;align-items:center;justify-content:center}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'hyp-cart-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildDrawer() {
    var overlay = document.createElement('div');
    overlay.className = 'hyp-cart-overlay';
    overlay.id = 'hyp-cart-overlay';

    var drawer = document.createElement('div');
    drawer.className = 'hyp-cart-drawer';
    drawer.id = 'hyp-cart-drawer';
    drawer.innerHTML =
      '<div class="hyp-cart-head"><h3>YOUR BAG</h3><button class="hyp-cart-close" id="hyp-cart-close">✕</button></div>' +
      '<div class="hyp-cart-items" id="hyp-cart-items"></div>' +
      '<div class="hyp-cart-foot"><div class="hyp-cart-subtotal"><span>SUBTOTAL</span><span id="hyp-cart-subtotal-amt">₹0</span></div>' +
      '<a href="/checkout" class="hyp-cart-checkout">CHECKOUT →</a></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    cartDrawer = drawer;
    cartBody = document.getElementById('hyp-cart-items');

    overlay.addEventListener('click', closeCart);
    document.getElementById('hyp-cart-close').addEventListener('click', closeCart);
  }

  function openCart() {
    document.getElementById('hyp-cart-overlay').classList.add('hyp-open');
    cartDrawer.classList.add('hyp-open');
  }

  function closeCart() {
    document.getElementById('hyp-cart-overlay').classList.remove('hyp-open');
    cartDrawer.classList.remove('hyp-open');
  }

  function renderCart(cart) {
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="hyp-cart-empty">YOUR BAG IS EMPTY</div>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item) {
        return '<div class="hyp-cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div class="hyp-cart-line-info">' +
            '<p class="hyp-cart-line-title">' + item.product_title + '</p>' +
            '<p class="hyp-cart-line-variant">' + (item.variant_title || '') + '</p>' +
            '<div class="hyp-cart-qty">' +
              '<button class="hyp-qty-minus">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="hyp-qty-plus">+</button>' +
            '</div>' +
            '<button class="hyp-cart-remove">REMOVE</button>' +
          '</div>' +
          '<div class="hyp-cart-line-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
      }).join('');
    }
    document.getElementById('hyp-cart-subtotal-amt').textContent = formatMoney(cart.total_price);
    cartCountEls = document.querySelectorAll('.hyp-cart-count');
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
  }

  function refreshCart(openAfter) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openAfter) openCart();
      });
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(true); })
      .catch(function () { alert('Could not add to cart. Please try again.'); });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  cartBody = null;
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.hyp-cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var qtySpan = line.querySelector('.hyp-cart-qty span');
    var qty = parseInt(qtySpan.textContent, 10);

    if (e.target.classList.contains('hyp-qty-plus')) changeLine(key, qty + 1);
    if (e.target.classList.contains('hyp-qty-minus')) changeLine(key, Math.max(0, qty - 1));
    if (e.target.classList.contains('hyp-cart-remove')) changeLine(key, 0);
  });

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-hyp-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-hyp-add-to-cart');
      addToCart(variantId, 1);
    }
    if (e.target.closest('[data-hyp-cart-open]')) {
      e.preventDefault();
      refreshCart(true);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    buildDrawer();
    refreshCart(false);
  });

  window.hypAddToCart = addToCart;
  window.hypOpenCart = function () { refreshCart(true); };
})();